// eslint-disable-next-line ember/no-computed-properties-in-native-classes
import { action, computed } from '@ember/object';
// eslint-disable-next-line ember/no-computed-properties-in-native-classes
import { filterBy } from '@ember/object/computed';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import type { Task } from 'ember-concurrency';
import { dropTask } from 'ember-concurrency';
import type LocationModel from 'garaje/models/location';
import type VisitorGuideSectionModel from 'garaje/models/visitor-guide-section';
import type { Locale } from 'garaje/utils/locale-options';
import LOCALE_OPTIONS, { isRTLLocale } from 'garaje/utils/locale-options';

interface VisitorEmailsVisitorGuideManageTranslationsModalComponentSignature {
  Args: {
    location: LocationModel;
    sections: VisitorGuideSectionModel[];
    reloadTask: Task<void, []>;
    saveTask: Task<void, []>;
    onClose: () => void;
  };
}

export default class VisitorEmailsVisitorGuideManageTranslationsModalComponent extends Component<VisitorEmailsVisitorGuideManageTranslationsModalComponentSignature> {
  localeOptions = LOCALE_OPTIONS;
  @tracked selectedLocale?: Partial<Locale> = {};

  @filterBy('args.sections', 'enabled', true) filteredSections!: VisitorGuideSectionModel[];

  @computed('args.location.{enabledLocales,enabledLocales.[]}', 'localeOptions.@each.value')
  get availableLocales(): Locale[] {
    const enabledLocales = this.args.location.enabledLocales;
    return this.localeOptions.filter((option) => enabledLocales.includes(option.value));
  }

  @computed('args.location.locale', 'localeOptions.@each.{label,value}')
  get defaultLocale(): string | undefined {
    return this.localeOptions.find((locale) => locale.value === this.args.location.locale)?.label;
  }

  @computed('selectedLocale.value')
  get isRTLLocale(): boolean {
    return isRTLLocale(this.selectedLocale?.value);
  }

  constructor(owner: unknown, args: VisitorEmailsVisitorGuideManageTranslationsModalComponentSignature['Args']) {
    super(owner, args);
    const firstLocale = this.args.location.enabledLocales[0];
    const selectedLocale = this.localeOptions.find((locale) => locale.value === firstLocale);

    this.selectedLocale = selectedLocale;

    void this.args.reloadTask.perform();
  }

  saveAndClose = dropTask(async () => {
    await this.args.saveTask.perform();
    this.args.onClose();
  });

  @action
  changeLocale(locale: Locale): void {
    this.selectedLocale = locale;
  }
}
